export const CSV_EXPORT_ERROR_MESSAGE = "Não foi possível concluir a exportação. Tente novamente.";
export const CSV_EXPORT_NO_DATA_MESSAGE = "Não há dados disponíveis para exportação no período selecionado.";
